import { createSlice } from '@reduxjs/toolkit';
import {
    getAutoformMetadata,
    getAutoformLevelMeta,
    getAutoformLevelData,
    getAutoformLevelDropdowns,
    addAutoformTableRow,
    saveAutoformRecords,
    deleteAutoformTableRow,
    refetchSelectedItemBackendData,
} from './autoformApi';

const initialState = {
    metadata: null,
    tables: {},
};

const autoformSlice = createSlice({
    name: 'autoform',
    initialState,
    reducers: {
        setSelectedItemForTable(state, action) {
            state.tables[action.payload.tableId] = state.tables[action.payload.tableId] || {};
            state.tables[action.payload.tableId].selectedItem = action.payload.itemId;
        },
        clearAutoformStore() {
            return initialState;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getAutoformMetadata.fulfilled, (state, action) => {
            state.metadata = action.payload;
        });
        builder.addCase(getAutoformLevelMeta.fulfilled, (state, action) => {
            state.tables[action.payload.tableId] = {
                ...(state.tables[action.payload.tableId] || {}),
                metadata: action.payload.meta,
            };
        });
        builder.addCase(getAutoformLevelData.fulfilled, (state, action) => {
            state.tables[action.payload.tableId] = {
                ...(state.tables[action.payload.tableId] || {}),
                data: action.payload.data,
            };
        });
        builder.addCase(getAutoformLevelDropdowns.fulfilled, (state, action) => {
            state.tables[action.payload.tableId] = {
                ...(state.tables[action.payload.tableId] || {}),
                dropdownOptions: action.payload.data,
            };
        });
        builder.addCase(addAutoformTableRow.fulfilled, (state, action) => {
            state.tables[action.payload.tableId] = state.tables[action.payload.tableId] || {};
            state.tables[action.payload.tableId].data = state.tables[action.payload.tableId].data || [];
            state.tables[action.payload.tableId].data.push(action.payload.data);
        });
        builder.addCase(saveAutoformRecords.fulfilled, (state, action) => {
            state.tables[action.payload.tableId] = state.tables[action.payload.tableId] || {};
            state.tables[action.payload.tableId].data = state.tables[action.payload.tableId].data || [];
            state.tables[action.payload.tableId].data = state.tables[action.payload.tableId].data.map((data) => {
                const toUpdate = action.payload.data.find(
                    (updatedItem) =>
                        updatedItem[action.payload.primaryKeyRecordName] === data[action.payload.primaryKeyRecordName]
                );
                if (toUpdate) {
                    return toUpdate;
                }
                return data;
            });
        });
        builder.addCase(deleteAutoformTableRow.fulfilled, (state, action) => {
            state.tables[action.payload.tableId] = state.tables[action.payload.tableId] || {};
            state.tables[action.payload.tableId].data = state.tables[action.payload.tableId].data || [];
            state.tables[action.payload.tableId].data = state.tables[action.payload.tableId].data.filter(
                (data) => data[action.payload.primaryKeyColumnName] !== action.payload.recordId
            );
        });
        builder.addCase(refetchSelectedItemBackendData.fulfilled, (state, action) => {
            state.tables[action.payload.tableId] = state.tables[action.payload.tableId] || {};
            state.tables[action.payload.tableId].data = state.tables[action.payload.tableId].data || [
                action.payload.data,
            ];
            state.tables[action.payload.tableId].data = state.tables[action.payload.tableId].data.map((data) =>
                data[action.payload.primaryKeyColumnName] !== action.payload.itemId ? data : action.payload.data
            );
        });
    },
});

export const { setSelectedItemForTable, clearAutoformStore } = autoformSlice.actions;
export default autoformSlice.reducer;
